import React from "react";
import { AlertTriangle, Layers, Package, Percent, Power, UserRound } from "lucide-react";

import { Switch } from "../../../../components/ui/switch";

import { DADOS, MODULOS } from "../formato";

function Chip({ icone: Icone, children, onClick }) {
  const Tag = onClick ? "button" : "span";
  return (
    <Tag type={onClick ? "button" : undefined} onClick={onClick}
      className={`inline-flex items-center gap-1.5 rounded-full border bg-background/60 px-3 py-1 text-xs font-medium ${onClick ? "hover:border-primary/50 hover:text-primary" : ""}`}>
      <Icone className="w-3.5 h-3.5 text-muted-foreground" />{children}
    </Tag>
  );
}

// Topo das regras: a campanha está ligada? E o resumo do que está valendo.
export default function CartaoStatus({ ativa, onAtiva, config, participando, onIrParaProdutos }) {
  const modulos = MODULOS.filter((m) => (config.modulos || ["Cardapio"]).includes(m.id)).map((m) => m.rotulo);
  const dados = DADOS.filter((d) => (config.dados_exigidos || []).includes(d.id)).map((d) => d.rotulo);
  const semProduto = participando === 0;
  return (
    <section data-e2e="cartao-status"
      className={`rounded-2xl border-2 p-4 sm:p-5 transition-colors ${ativa ? "border-emerald-500/50 bg-gradient-to-r from-emerald-500/15 via-emerald-500/5 to-transparent" : "border-border bg-card"}`}>
      <div className="flex items-center gap-4">
        <div className={`w-12 h-12 rounded-2xl flex items-center justify-center shrink-0 ${ativa ? "bg-emerald-500 text-white shadow-lg shadow-emerald-500/30" : "bg-muted text-muted-foreground"}`}>
          <Power className="w-6 h-6" />
        </div>
        <div className="flex-1 min-w-0">
          <p className="text-lg font-bold leading-tight">{ativa ? "Campanha ligada" : "Campanha desligada"}</p>
          <p className="text-sm text-muted-foreground">
            {ativa ? "Os clientes estão recebendo ofertas sorteadas." : "Ninguém recebe oferta enquanto estiver desligada."}
          </p>
        </div>
        <Switch checked={ativa} onCheckedChange={onAtiva} aria-label="Ligar campanha" className="scale-125 mr-1" />
      </div>
      <div className="flex flex-wrap gap-2 mt-4">
        <Chip icone={Package} onClick={onIrParaProdutos}>{participando} {participando === 1 ? "produto" : "produtos"}</Chip>
        <Chip icone={Percent}>até {String(config.desconto_max_padrao_pct ?? "").replace(".", ",")}%</Chip>
        <Chip icone={Layers}>{modulos.join(", ")}</Chip>
        <Chip icone={UserRound}>{dados.join(" + ")}</Chip>
      </div>
      {ativa && semProduto && (
        <div className="mt-3 flex items-center gap-2 rounded-lg border border-amber-500/40 bg-amber-500/10 px-3 py-2 text-xs">
          <AlertTriangle className="w-4 h-4 text-amber-500 shrink-0" />
          <span className="flex-1">Nenhum produto participando: ninguém vai receber oferta.</span>
          <button type="button" onClick={onIrParaProdutos} className="font-semibold text-primary hover:underline">Marcar produtos</button>
        </div>
      )}
    </section>
  );
}
